import { useState } from 'react';
import { AlertCircle, CheckCircle2, Info, AlertTriangle, X } from 'lucide-react';

export default function Alert({
  type = 'info', // 'info' | 'success' | 'warning' | 'danger'
  title,
  children,
  dismissible = false,
  className = '',
}) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const icons = {
    info: Info,
    success: CheckCircle2,
    warning: AlertTriangle,
    danger: AlertCircle,
  };

  const Icon = icons[type] || Info;

  return (
    <div className={`alert alert--${type} ${className}`}>
      <Icon className="alert__icon" />
      <div className="alert__content">
        {title && <div className="alert__title">{title}</div>}
        <div>{children}</div>
      </div>
      {dismissible && (
        <button onClick={() => setDismissed(true)} className="alert__close" aria-label="Dismiss alert">
          <X size={16} />
        </button>
      )}
    </div>
  );
}
